{
	"Features": {
		"Feature 01": {
			"permission": "Admin",
			"textObject": "title: Misdemeanors\nimageDescription: legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law\ndescription: Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "Misdemeanor charges are less severe criminal offenses typically punishable by fines, probation, community service, or a short jail sentence, usually lasting less than one year. They are less serious than felonies but can still have significant legal and personal consequences."
				},
				"title": {
					"translations": {
						"en": "Misdemeanors",
						"en-US": "Misdemeanors"
					},
					"value": "Misdemeanors"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "legal documents spread around, in soft, dramatic courtroom lighting, representing misdemeanor law"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2FFeature%2001%20Image%2FDALL%C2%B7E%202025-02-20%2023.24.18.jpeg?alt=media&token=11cfd4dd-07d5-4e20-86b0-746c55047c96",
				"formattedSize": "195.76 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.24.18.jpeg",
				"path": "uploads/home/Features/Feature 01 Image/DALL·E 2025-02-20 23.24.18.jpeg",
				"query": "?as=run",
				"size": 200461,
				"type": "image/jpeg",
				"updated": "2025-02-21T09:14:20.160Z",
				"width": 1792
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"textObject": "title: Felonys\nimageDescription: a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting\ndescription: Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "Felonies encompass a wide range of crimes, from violent acts like murder and robbery to non-violent offenses such as drug trafficking and embezzlement."
				},
				"title": {
					"translations": {
						"en": "Felonys",
						"en-US": "Felonys"
					},
					"value": "Felonys"
				}
			}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "a gavel, legal documents, and a pair of handcuffs under dramatic courtroom lighting"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2FFeature%2002%20Image%2FDALL%C2%B7E%202025-02-20%2023.48.46.jpeg?alt=media&token=ea716eca-4430-411c-af8e-a7998e4883fd",
				"formattedSize": "285.21 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.48.46.jpeg",
				"path": "uploads/home/Features/Feature 02 Image/DALL·E 2025-02-20 23.48.46.jpeg",
				"query": "?as=run",
				"size": 292052,
				"type": "image/jpeg",
				"updated": "2025-02-21T09:14:30.380Z",
				"width": 1792
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"textObject": "title: DUI/DWI\nimageDescription: A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom.\ndescription: DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "DUI, which stands for Driving Under the Influence, is a criminal offense where a person is charged for operating a motor vehicle while impaired by alcohol or drugs."
				},
				"title": {
					"translations": {},
					"value": "DUI/DWI"
				}
			}
		},
		"Feature 03 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "A set of car keys on a wooden table next to an overturned glass with spilled alcohol, symbolizing DUI/DWI. A revoked driver’s license, gavel, and handcuffs represent the legal consequences. In the background, blurred car taillights fade into the night, emphasizing lost freedom."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2FFeature%2003%20Image%2FDALL%C2%B7E%202025-02-20%2023.54.39.jpeg?alt=media&token=89c5b7a9-7590-4e1d-9567-eec928beae2e",
				"formattedSize": "246.22 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-20 23.54.39.jpeg",
				"path": "uploads/home/Features/Feature 03 Image/DALL·E 2025-02-20 23.54.39.jpeg",
				"query": "?as=run",
				"size": 252131,
				"type": "image/jpeg",
				"updated": "2025-02-21T09:14:38.278Z",
				"width": 1792
			}
		},
		"Feature 04": {
			"permission": "Admin",
			"textObject": "title: Probation Violations\nimageDescription: A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations.\ndescription: These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes.",
			"translations": {},
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "These charges occur when an individual who has been placed on probation fails to comply with the terms and conditions of their probationary sentence, such as missing required meetings with a probation officer, failing drug tests, or committing new crimes."
				},
				"title": {
					"translations": {},
					"value": "Probation Violations"
				}
			}
		},
		"Feature 04 Image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "A wooden desk with neatly arranged legal documents, a checklist labeled 'Court-Ordered Responsibilities,' and a scheduled appointment notice. A pen rests on the checklist, symbolizing the need for compliance. A gavel and case files are nearby, representing legal oversight. In the background, a blurred courthouse setting suggests the formal nature of legal obligations."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%2FFeature%2004%20Image%2FDALL%C2%B7E%202025-02-21%2000.07.30.jpeg?alt=media&token=bacd7911-ef04-4dd9-a827-03d398bdaad0",
				"formattedSize": "255.31 KB",
				"height": 1024,
				"name": "DALL·E 2025-02-21 00.07.30.jpeg",
				"path": "uploads/home/Features/Feature 04 Image/DALL·E 2025-02-21 00.07.30.jpeg",
				"query": "?as=run",
				"size": 261433,
				"type": "image/jpeg",
				"updated": "2025-02-21T09:14:49.683Z",
				"width": 1792
			}
		},
		"bgAltBase": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "mx-2 sm:mx-4 py-8"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "mx-auto border-8 border-primary rounded w-full text-center"
				},
				"featureContentClass": {
					"translations": {},
					"value": "p-8"
				},
				"featureTitleContainerClass": {
					"translations": {},
					"value": "w-full mt-4 mb-2"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 lg:grid-cols-2 gap-16"
				},
				"imageClass": {
					"translations": {},
					"value": "bottom-rounded-full"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "We have spent 23 years representing Alabama residents with criminal matters."
			},
			"type": "TextArea",
			"value": "We have spent 23 years representing Alabama residents with criminal matters."
		},
		"index": 0,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "04"
		},
		"theme": {
			"permission": "Admin",
			"translations": {
				"en-US": "light"
			},
			"type": "TextInput",
			"value": "light"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Practice Areas"
			},
			"type": "TextInput",
			"value": "Practice Areas"
		}
	},
	"Features Hero": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Gentleman wearing glasses and a dark suit"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Hero%2FFeature%2001%20Image%2FThomas-Moore2.png?alt=media&token=bbea874b-f423-427c-9e36-7f1bc15a26c8",
				"formattedSize": "136.74 KB",
				"height": 852,
				"name": "Thomas-Moore2.png",
				"path": "uploads/home/Features Hero/Feature 01 Image/Thomas-Moore2.png",
				"query": "?as=run:0",
				"size": 140024,
				"type": "image/png",
				"updated": "2026-04-06T01:25:27.822Z",
				"width": 619
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Features Hero Content"
				}
			}
		},
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Corner Office Building"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Hero%2FbgImage%2F55613967-0-Homepage-hero-main-b.jpg?alt=media&token=da7a67e6-6537-4553-80a0-d2d74694f874",
				"formattedSize": "137.08 KB",
				"height": 1066,
				"name": "55613967-0-Homepage-hero-main-b.jpg",
				"path": "uploads/home/Features Hero/bgImage/55613967-0-Homepage-hero-main-b.jpg",
				"query": "?as=run",
				"size": 140373,
				"type": "image/jpeg",
				"updated": "2026-04-06T01:24:29.706Z",
				"width": 1920
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full opacity-20 h-[calc(100vh-120px)] object-cover"
				},
				"contentClass": {
					"translations": {},
					"value": "h-[calc(100vh-120px)] mx-2 sm:mx-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "m-auto"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-2 gap-2 sm:gap-4"
				},
				"featuresContainerClassHold": {
					"translations": {},
					"value": "[@media(min-aspect-ratio:2/3)]:grid-cols-2"
				},
				"imageClass": {
					"translations": {},
					"value": "mx-auto w-full h-full"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "mask-b-from-60% mask-b-to-100% w-full p-8 sm:p-16"
				}
			}
		},
		"index": 1,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		}
	},
	"Features Hero Content": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "<br />\n\n# Criminal & DUI Attorney in Birmingham, AL\n\n<br />\n\n## Our experienced team is here to provide you with the legal representation you deserve.\n\n<br />"
				}
			}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "The Thomas J. Moore Law Office banner in white and gold"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Hero%20Content%2FFeature%2001%20Image%2Fbanner.png?alt=media&token=83e8b9d1-3871-497d-b1a7-6d7d21191e67",
				"formattedSize": "9.32 KB",
				"height": 634,
				"name": "banner.png",
				"path": "uploads/home/Features Hero Content/Feature 01 Image/banner.png",
				"query": "?as=run:0",
				"size": 9547,
				"type": "image/png",
				"updated": "2026-04-06T03:41:51.672Z",
				"width": 2294
			}
		},
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "tel:+12058468958"
				},
				"label": {
					"translations": {},
					"value": "Call Now"
				}
			}
		},
		"actionIcon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z\"]}",
				"name": "faPhone"
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "btn btn-outline btn-md sm:btn-wide sm:btn-lg hover-ripple rounded text-xl sm:text-2xl"
				},
				"contentClass": {
					"translations": {},
					"value": "text-left"
				},
				"descriptionClass": {
					"translations": {},
					"value": "text-left"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "w-full"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"index": 2
	},
	"Features Specialize": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Three people walking down some steps"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Specialize%2FFeature%2001%20Image%2FThree%20People%20Walking.jpg?alt=media&token=5857d647-6b3b-40aa-bd7a-5c5c8114fe8f",
				"formattedSize": "26.48 KB",
				"height": 378,
				"name": "Three People Walking.jpg",
				"path": "uploads/home/Features Specialize/Feature 01 Image/Three People Walking.jpg",
				"query": "?as=run",
				"size": 27117,
				"type": "image/jpeg",
				"updated": "2026-04-03T06:57:52.547Z",
				"width": 450
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "---\n\n**Thomas J Moore** specializes in providing expert legal representation to individuals facing criminal charges within the state of Alabama. Our firm is committed to defending our clients rights and helping them navigating the complexities of the criminal justice system.\n\nOur firm works closely with our clients to provide personalized representation to each client. Through this process we understand the unique circumstances, develop tailored defense strategies, and provide support throughout the legal process.\n\nWe take pride in defending our clients against charges such as DUI (Driving Under the Influence), drug offenses, domestic violence, theft, white-collar crimes, assault, and more.\n\nDon’t let legal troubles define your future. Take the first step towards a brighter tomorrow. Contact the Thomas J. Moore Criminal Law Firm today for a free consultation.\n\nWe’re here to stand by your side and protect your rights.\n\n---"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContainerClass": {
					"translations": {},
					"value": "w-full m-auto"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-4"
				},
				"imageClass": {
					"translations": {},
					"value": "m-auto border-8 border-primary rounded"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "p-16"
				}
			}
		},
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Features Thomas": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "### Thomas J Moore\n---\n\nI look for a limited number of cases that are worth my absolute best efforts.\n\nI don’t want to be everyone’s attorney.  \nI want cases that are worth my undivided attention.\n \nIf you want an attorney who knows who you are, knows your story,\nand won’t treat your case like it’s simply another file, let’s talk.\n\nIf your case warrants my absolute time, attention, and urgency, \nthen please contact me."
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {}
		},
		"Feature 02 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Man working at a desk on a laptop in a law office."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FFeatures%20Thomas%2FFeature%2002%20Image%2FWorking%20at%20Desk.jpg?alt=media&token=e6639f51-4e60-4c0b-a18a-29908296685c",
				"formattedSize": "17.89 KB",
				"height": 363,
				"name": "Working at Desk.jpg",
				"path": "uploads/home/Features Thomas/Feature 02 Image/Working at Desk.jpg",
				"query": "?as=run",
				"size": 18323,
				"type": "image/jpeg",
				"updated": "2026-04-03T22:55:08.466Z",
				"width": 450
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContainerClass": {
					"translations": {},
					"value": "w-full m-auto"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-4"
				},
				"imageClass": {
					"translations": {},
					"value": "m-auto border-8 border-primary rounded"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "p-16"
				}
			}
		},
		"index": 4,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "06"
		}
	},
	"Head": {
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Thomas J. Moore, experienced criminal and DUI attorney serving Birmingham, Alabama, pictured with courthouse background and law office branding."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FHead%2Fimage%2Ftj-moore-preview.jpg?alt=media&token=62fa5ba3-da84-449e-80dc-8c6140588d55",
				"formattedSize": "131.79 KB",
				"height": 630,
				"name": "tj-moore-preview.jpg",
				"path": "uploads/home/Head/image/tj-moore-preview.jpg",
				"query": "?as=run",
				"size": 134951,
				"type": "image/jpeg",
				"updated": "2026-04-06T05:00:25.304Z",
				"width": 1200
			}
		},
		"index": 5,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		}
	},
	"Hero": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "tel:+12058468958"
				},
				"label": {
					"translations": {},
					"value": "Call Now"
				}
			}
		},
		"actionIcon": {
			"permission": "Admin",
			"translations": {},
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z\"]}",
				"name": "faPhone"
			}
		},
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Corner Office Building"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FHero%2FbgImage%2F55613967-0-Homepage-hero-main-b.jpg?alt=media&token=5759065a-985c-466a-886e-b20eb0ef1957",
				"formattedSize": "137.08 KB",
				"height": 1066,
				"name": "55613967-0-Homepage-hero-main-b.jpg",
				"path": "uploads/home/Hero/bgImage/55613967-0-Homepage-hero-main-b.jpg",
				"query": "?as=run",
				"size": 140373,
				"type": "image/jpeg",
				"updated": "2026-04-03T04:45:28.020Z",
				"width": 1920
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "btn btn-outline btn-md sm:btn-wide sm:btn-lg hover-ripple rounded p-8 text-xl sm:text-2xl md:-mt-32 lg:-mt-48"
				},
				"bgImageClass": {
					"translations": {},
					"value": "absolute top-0 left-0 opacity-20 object-cover -z-10 w-full h-full"
				},
				"heroContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 md:grid-cols-2 gap-2 sm:gap-4 items-center"
				},
				"imageClass": {
					"translations": {},
					"value": "w-2/3 mx-auto mask-b-from-60% mask-b-to-100%"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "md:row-span-2"
				}
			}
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Gentleman wearing glasses and a dark suit"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FHero%2Fimage%2FThomas-Moore2.png?alt=media&token=f37cb70d-7721-4eac-b9d4-789b3f75728c",
				"formattedSize": "136.74 KB",
				"height": 852,
				"name": "Thomas-Moore2.png",
				"path": "uploads/home/Hero/image/Thomas-Moore2.png",
				"query": "?as=run:0",
				"size": 140024,
				"type": "image/png",
				"updated": "2026-04-03T04:46:16.551Z",
				"width": 619
			}
		},
		"index": 6,
		"markedContent": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "# Criminal & DUI Attorney in Birmingham, AL\n\n<br />\n\n## Our experienced team is here to provide you with the legal representation you deserve."
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"Home": {
		"index": 7
	},
	"SideBySide": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "mx-2 sm:mx-4 my-8"
				},
				"imageClass": {
					"translations": {},
					"value": "m-auto border-8 border-primary rounded"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "p-16"
				}
			}
		},
		"image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Three people walking down some steps"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2Fimage%2FThree%20People%20Walking.jpg?alt=media&token=c45564b7-d23f-4aab-9db6-1ef76af1f4c8",
				"formattedSize": "26.48 KB",
				"height": 378,
				"name": "Three People Walking.jpg",
				"path": "uploads/home/SideBySide/image/Three People Walking.jpg",
				"query": "?as=run",
				"size": 27117,
				"type": "image/jpeg",
				"updated": "2025-02-21T05:27:49.818Z",
				"width": 450
			}
		},
		"index": 8,
		"markedContent": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "---\n\n**Thomas J Moore** specializes in providing expert legal representation to individuals facing criminal charges within the state of Alabama. Our firm is committed to defending our clients rights and helping them navigating the complexities of the criminal justice system.\n\nOur firm works closely with our clients to provide personalized representation to each client. Through this process we understand the unique circumstances, develop tailored defense strategies, and provide support throughout the legal process.\n\nWe take pride in defending our clients against charges such as DUI (Driving Under the Influence), drug offenses, domestic violence, theft, white-collar crimes, assault, and more.\n\nDon’t let legal troubles define your future. Take the first step towards a brighter tomorrow. Contact the Thomas J. Moore Criminal Law Firm today for a free consultation.\n\nWe’re here to stand by your side and protect your rights.\n\n---"
		}
	},
	"SideBySide 02": {
		"actionHref": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": ""
		},
		"actionImage": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2002%2FactionImage%2Ftop-100-trial-lawyer.png?alt=media&token=5a23bbcb-55b8-4ff4-a5c9-e84ff00b6aa9",
				"formattedSize": "150.31 KB",
				"height": 1411,
				"name": "top-100-trial-lawyer.png",
				"path": "uploads/home/SideBySide 02/actionImage/top-100-trial-lawyer.png",
				"query": "?w=100,200,300,450&as=run",
				"size": 153919,
				"type": "image/png",
				"updated": "2025-02-21T07:02:41.242Z",
				"width": 1411
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "I look for a limited number of cases that are worth my absolute best efforts.\n\nI don’t want to be everyone’s attorney.  \nI want cases that are worth my undivided attention.\n \nIf you want an attorney who knows who you are, knows your story,\nand won’t treat your case like it’s simply another file, let’s talk.\n\nIf your case warrants my absolute time, attention, and urgency, \nthen please contact me."
			},
			"type": "TextArea",
			"value": "### Thomas J Moore\n---\n\nI look for a limited number of cases that are worth my absolute best efforts.\n\nI don’t want to be everyone’s attorney.  \nI want cases that are worth my undivided attention.\n \nIf you want an attorney who knows who you are, knows your story,\nand won’t treat your case like it’s simply another file, let’s talk.\n\nIf your case warrants my absolute time, attention, and urgency, \nthen please contact me."
		},
		"flipped": {
			"permission": "Admin",
			"translations": {
				"en-US": "true"
			},
			"type": "TextInput",
			"value": "true"
		},
		"image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fhome%2FSideBySide%2002%2Fimage%2FWorking%20at%20Desk.jpg?alt=media&token=c1d0e6e9-3aef-426b-8765-54c3fd60f274",
				"formattedSize": "17.89 KB",
				"height": 363,
				"name": "Working at Desk.jpg",
				"path": "uploads/home/SideBySide 02/image/Working at Desk.jpg",
				"query": "?as=run",
				"size": 18323,
				"type": "image/jpeg",
				"updated": "2025-02-21T05:32:02.464Z",
				"width": 450
			}
		},
		"index": 9
	},
	"Testimonials": {
		"index": 10,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "05"
		},
		"theme": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "light"
		},
		"title": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Testimonials"
		}
	}
}